import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { Link } from "./library/link";
import { ResponsivePicture } from "../../../Shared/components/Image";
import { slugify } from "../../../Shared/utils/string";
export const FeaturedContentBlock = (props)=>/*#__PURE__*/ _jsxs("div", {
        className: "featured-content-block container--full gutter--m align--center",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "featured-content-block__text",
                children: [
                    /*#__PURE__*/ _jsx("header", {
                        children: /*#__PURE__*/ _jsx("h2", {
                            "data-anchor": slugify(props.title),
                            className: "featured-content-block__title title--l",
                            children: props.title
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text--styled",
                        dangerouslySetInnerHTML: {
                            __html: props.html
                        }
                    }),
                    props.linkUrl && props.linkTitle && /*#__PURE__*/ _jsx("footer", {
                        className: "featured-content-block__footer",
                        children: /*#__PURE__*/ _jsx(Link, {
                            className: "button button--primary button--arrow",
                            url: props.linkUrl,
                            children: /*#__PURE__*/ _jsx("span", {
                                className: "button__label",
                                children: props.linkTitle
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "featured-content-block__media image-block__wrapper",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "featured-content-block__visual image-block__inner",
                    children: /*#__PURE__*/ _jsx(ResponsivePicture, {
                        imgClassName: "featured-content-block__image image-block__image",
                        defaultImageUrl: props.imageUrlFallback,
                        cropsPerMedia: [
                            {
                                crops: [
                                    {
                                        url: props.imageUrl,
                                        width: 300
                                    },
                                    {
                                        url: props.imageUrlLarge,
                                        width: 600
                                    }
                                ]
                            }
                        ],
                        width: 478,
                        height: 478,
                        alt: props.imageAlt
                    })
                })
            })
        ]
    });
{}